import { render, staticRenderFns } from "./TabMaterials.vue?vue&type=template&id=5f7829cb&scoped=true&"
import script from "./TabMaterials.vue?vue&type=script&lang=ts&"
export * from "./TabMaterials.vue?vue&type=script&lang=ts&"
import style0 from "./TabMaterials.vue?vue&type=style&index=0&id=5f7829cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7829cb",
  null
  
)

export default component.exports